import React from "react";
import CompanyFilter from "../../../../core/common/crmComponents/CompanyFilter";
import CommonFilter from "../../../../core/common/crmComponents/filters/CommonFilter";
import ClearAllFilters from "../../../../core/common/crmComponents/filters/ClearAllFilters";
import { MODULES } from "../../../../core/data/constants/moduleConstants";
import ReloadButton from "../../../../core/common/crmComponents/ReloadButton";

const CardHeader = ({
  toggleLayout,
  layout,
  selectedCompany,
  setSelectedCompany,
}) => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");

  return (
    <div className="card-header py-2">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
        {/* Left Section */}
        <div className="d-flex flex-wrap gap-3">
          <ReloadButton moduleName={MODULES.DEALS} />

          {/* Company Filter */}
          <CompanyFilter
            selectedCompany={selectedCompany}
            setSelectedCompany={setSelectedCompany}
            user={user}
          />
        </div>

        {/* Right Section */}
        <div className="d-flex align-items-center gap-3">
          <div className="gap-1 d-flex align-items-center flex-wrap">
            <CommonFilter module={MODULES.DEALS} />
            <ClearAllFilters module={MODULES.DEALS} />
          </div>

          {/* Layout Toggle */}
          <div className="view-icons p-0 d-flex ">
            <div
              to="#"
              className={`view-icon pb-1 ${layout === "list" ? "active" : ""}`}
              onClick={() => toggleLayout("list")}
            >
              <i className="ti ti-list-tree" />
            </div>
            <div
              to="#"
              className={`view-icon pb-1 ${layout === "grid" ? "active" : ""}`}
              onClick={() => toggleLayout("grid")}
            >
              <i className="ti ti-grid-dots" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardHeader;
